export default __webpack_public_path__ + "log-out-9096a536c8440da28cd00d926875161b.svg";